// import React, { useState } from "react";
// import { Eye, EyeOff, Copy, CheckCircle2 } from "lucide-react";
// import assets from "../../assets/png";
// import { Tooltip } from "@mui/material";
// import { usePermission } from "../../hooks/usePermission";
// import { toast } from "sonner";

// interface WalletSummaryCardProps {
//   balance: number;
//   lastTopUpAmount?: number;
//   lastTopUpDate?: string;
//   walletId?: string;
//   walletName?: string;
//   lastSynced?: string;
//   verified?: boolean;
//   progress?: number; // 0 - 100
// }

// const WalletSummaryCard: React.FC<WalletSummaryCardProps> = ({
//   balance,
//   lastTopUpAmount,
//   lastTopUpDate,
//   walletId,
//   walletName,
//   lastSynced,
//   verified = true,
//   progress = 70,
// }) => {
//   const [showBalance, setShowBalance] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const { hasPermission } = usePermission();

//   const handleCopy = () => {
//     if (!hasPermission("view wallet")) {
//       toast.error("You do not have permission to copy the wallet ID.");
//       return;
//     }
//     if (walletId) {
//       navigator.clipboard.writeText(walletId);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 1500);
//     }
//   };

//   const circleRadius = 32;
//   const circumference = 2 * Math.PI * circleRadius;
//   const dashOffset = ((100 - progress) / 100) * circumference;
//   const bgImageUrl = assets.WalletBg; // Replace with your image URL

//   return (
//     <div className="relative bg-gradient-to-r from-[#000A90] via-[#000A90] to-[#000A90] text-white rounded-2xl p-5 flex justify-between items-end overflow-hidden shadow-lg">
//       {/* Optional pattern overlay */}
//       <div
//         className="absolute inset-0 opacity-10 bg-cover bg-right"
//         style={{ backgroundImage: `url(${bgImageUrl})` }}
//       />

//       {/* Left content */}
//       <div className="relative z-10 flex items-center gap-4">
//         {/* Circular progress */}
//         <div className="w-20 h-20 rounded-full flex items-center justify-center flex-shrink-0 relative">
//           <div className="absolute inset-0 bg-gradient-to-br from-[#1a3a7f] to-[#0A1F5C] rounded-full"></div>
//           <svg className="w-20 h-20 -rotate-90 relative z-10">
//             <circle
//               cx="40"
//               cy="40"
//               r={circleRadius}
//               stroke="rgba(255,255,255,0.2)"
//               strokeWidth="7"
//               fill="none"
//             />
//             <circle
//               cx="40"
//               cy="40"
//               r={circleRadius}
//               stroke="#FFFFFF"
//               strokeWidth="7"
//               fill="none"
//               strokeDasharray={circumference}
//               strokeDashoffset={dashOffset}
//               strokeLinecap="round"
//             />
//           </svg>
//         </div>

//         {/* Wallet info */}
//         <div>
//           <div className="flex items-center gap-3 mb-1">
//             <h2 className="text-3xl font-bold">
//               {showBalance ? `₦ ${balance.toLocaleString()}` : "••••••••"}
//             </h2>
//             <button
//               onClick={() => {
//                 if (!hasPermission("view wallet")) {
//                    toast.error("You do not have permission to view the wallet balance.");
//                   return;
//                 }
//                 setShowBalance(true);
//               }}
//               className="text-white/70 hover:text-white transition p-1"
//             >
//               {showBalance ? <EyeOff size={20} /> : <Eye size={20} />}
//             </button>
//             <button
//               onClick={() => window.location.reload()}
//               className="text-white/70 hover:text-white transition p-1"
//               title="Resync wallet"
//             >
//               <svg
//                 width="20"
//                 height="20"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
//               </svg>
//             </button>
//           </div>

//           {lastTopUpAmount && (
//             <p className="text-xs text-white/70 mb-2">
//               Last Top-Up: ₦{lastTopUpAmount.toLocaleString()} - {lastTopUpDate}
//             </p>
//           )}

//           <div className="space-y-0.5 text-xs">
//             {walletId && (
//               <div className="flex items-center gap-2">
//                 {/* <span className="text-white/60">Wallet Number:</span> */}
//                 <span className="font-medium text-white">
//                   {/* {hasPermission("view wallet") ? `₦ ${walletId}` : "••••••••••••••••"} */}

//                   </span>
//                 {/* <Tooltip title={copied ? "Copied!" : "Copy Wallet ID"}>
//                   <button
//                     onClick={handleCopy}
//                     className="text-white/60 hover:text-white transition"
//                   >
//                     <Copy size={14} />
//                   </button>
//                 </Tooltip> */}
//               </div>
//             )}
//             {/* {walletName && (
//               <div className="flex items-center gap-2">
//                 <span className="text-white/60">Wallet Name:</span>
//                 <span className="font-medium text-white">
//                   {hasPermission("view wallet") ? `₦ ${walletName}` : "••••••••••••••••"}
//                 </span>
//               </div>
//             )} */}
//            {lastSynced && <div className="flex items-center gap-2">
//               <span className="text-white/60">Last synced:</span>
//               <span className="font-medium text-white">{lastSynced}</span>
//             </div>}
//           </div>
//         </div>
//       </div>

//       {/* Right badge */}
//       {verified && (
//         <div className="relative z-10">
//           <div className="flex items-center gap-1.5 bg-[#DDD0FB] backdrop-blur-sm text-[#6226EF] text-xs px-3 py-1.5 rounded-full border border-white/20">
//             <CheckCircle2 size={14} />
//             Wallet Verified
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default WalletSummaryCard;



import React, { useState } from "react";
import { motion } from "framer-motion";
import { Eye, EyeOff, CheckCircle2, RefreshCw, TrendingUp, TrendingDown } from "lucide-react";
import { usePermission } from "../../hooks/usePermission";
import { toast } from "sonner";

interface WalletSummaryCardProps {
  balance: number;
  lastTopUpAmount?: number;
  lastTopUpDate?: string;
  lastSynced?: string;
  verified?: boolean;
  trendPercentage?: number;
  trend?: "increase" | "decrease";
}

const WalletSummaryCard: React.FC<WalletSummaryCardProps> = ({
  balance,
  lastTopUpAmount,
  lastTopUpDate,
  lastSynced,
  verified = true,
  trendPercentage,
  trend,
}) => {
  const [showBalance, setShowBalance] = useState(false);
  const { hasPermission } = usePermission();

  const hasTrend = typeof trendPercentage === "number";
  const isIncrease = trend === "increase";
  const progress = hasTrend ? Math.min(Math.abs(trendPercentage as number), 100) : 0;

  const circleRadius = 34;
  const circumference = 2 * Math.PI * circleRadius;
  const dashOffset = ((100 - progress) / 100) * circumference;

  return (
    <div className="relative rounded-3xl p-6 text-white overflow-hidden shadow-2xl bg-gradient-to-br from-[#020B3F] via-[#000A90] to-[#1A1F71]">

      {/* Background glow */}
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-purple-500 opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-blue-400 opacity-20 blur-3xl rounded-full"></div>

      {/* Content */}
      <div className="relative z-10 flex justify-between items-center">

        {/* LEFT SIDE */}
        <div className="flex items-center gap-5">

          {/* Progress Circle */}
          <div className="relative w-20 h-20">
            <svg className="w-full h-full -rotate-90">
              <circle
                cx="40"
                cy="40"
                r={circleRadius}
                stroke="rgba(255,255,255,0.15)"
                strokeWidth="6"
                fill="none"
              />
              <motion.circle
                cx="40"
                cy="40"
                r={circleRadius}
                stroke={hasTrend ? `url(#${isIncrease ? "grad-up" : "grad-down"})` : "rgba(255,255,255,0.15)"}
                strokeWidth="6"
                fill="none"
                strokeDasharray={circumference}
                strokeLinecap="round"
                initial={{ strokeDashoffset: circumference }}
                animate={{ strokeDashoffset: dashOffset }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              />
              <defs>
                <linearGradient id="grad-up">
                  <stop offset="0%" stopColor="#00F5A0" />
                  <stop offset="100%" stopColor="#00D9F5" />
                </linearGradient>
                <linearGradient id="grad-down">
                  <stop offset="0%" stopColor="#FF6B6B" />
                  <stop offset="100%" stopColor="#FFB199" />
                </linearGradient>
              </defs>
            </svg>

            <div className="absolute inset-0 flex items-center justify-center">
              {hasTrend ? (
                <motion.span
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.6, duration: 0.4, ease: "backOut" }}
                  className={`flex items-center gap-0.5 text-[11px] font-bold ${
                    isIncrease ? "text-[#00F5A0]" : "text-[#FF6B6B]"
                  }`}
                >
                  <motion.span
                    animate={{ y: isIncrease ? [0, -2, 0] : [0, 2, 0] }}
                    transition={{ delay: 1, duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
                    className="flex"
                  >
                    {isIncrease ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
                  </motion.span>
                  {Math.abs(trendPercentage as number).toFixed(2)}%
                </motion.span>
              ) : (
                <span className="text-xs text-white/40">--</span>
              )}
            </div>
          </div>

          {/* Wallet Info */}
          <div>
            <p className="text-sm text-white/60 mb-1">Wallet Balance</p>

            <div className="flex items-center gap-3">
              <h1 className="text-3xl font-bold tracking-wide">
                {showBalance
                  ? `₦ ${balance.toLocaleString()}`
                  : "••••••••"}
              </h1>

              <button
                onClick={() => {
                  if (!hasPermission("view wallet")) {
                    toast.error("No permission to view balance");
                    return;
                  }
                  setShowBalance(!showBalance);
                }}
                className="p-1 hover:bg-white/10 rounded-full transition"
              >
                {showBalance ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>

              <button
                onClick={() => window.location.reload()}
                className="p-1 hover:bg-white/10 rounded-full transition"
                title="Resync wallet"
              >
                <RefreshCw size={18} />
              </button>
            </div>

            {/* Last Top Up */}
            {lastTopUpAmount && (
              <p className="text-xs text-white/60 mt-1">
                +₦{lastTopUpAmount.toLocaleString()} • {lastTopUpDate}
              </p>
            )}

            {/* FIXED LAST SYNCED (VISIBLE + PREMIUM) */}
            {lastSynced && (
              <div className="flex items-center gap-2 mt-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-sm border border-white/10 w-fit">
                <span className="w-3 h-3 bg-green-500 rounded-full animate-pulse border border-green-300"></span>
                <span className="text-xs text-white/80">
                  Last synced: <span className="font-medium">{lastSynced}</span>
                </span>
              </div>
            )}
          </div>
        </div>

        {/* RIGHT SIDE */}
        {verified && (
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20">
            <CheckCircle2 size={16} className="text-green-400" />
            <span className="text-xs font-medium">Verified</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletSummaryCard;